import './app.tsx';
// Host document metadata only. All views, selection and menu state are compiled from NEX.
const root = document.getElementById('root');
function syncMetadata() {
  const site = root?.querySelector<HTMLElement>('[data-locale]');
  if (!site) return;
  document.documentElement.lang = site.dataset.locale || 'hy';
  document.title = site.dataset.pageTitle || 'A Engineering';
}
if (root) new MutationObserver(syncMetadata).observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['data-locale','data-page-title']});
syncMetadata();
